import React from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

const RewardsPage = () => {
  return (
    <>
      {/* Override global styles to enable scrolling for RewardsPage */}
      <style>{`
        html, body, #root {
          overflow-y: auto !important;
          height: auto !important;
          min-height: 100vh !important;
        }
      `}</style>
      <div className="rewards-page" style={{ 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        overflowX: 'hidden',
        overflowY: 'auto',
        width: '100%'
      }}>
        <Header onLogin={() => {}} onSignUp={() => {}} />
      
      {/* Main Content */}
      <div style={{
        paddingTop: '80px', // Account for fixed header
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '80px 20px 40px 20px',
        boxSizing: 'border-box',
        minHeight: 'auto'
      }}>
        
        {/* White Box Container */}
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '40px',
          maxWidth: '1200px',
          width: '100%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          marginBottom: '40px'
        }}>
          
          {/* Page Title */}
          <div style={{
            textAlign: 'center',
            marginBottom: '40px'
          }}>
            <h1 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: '#667eea',
              marginBottom: '16px'
            }}>
              🏆 Winners & Rewards
            </h1>
                         <p style={{
               fontSize: '1.2rem',
               color: '#64748b',
               maxWidth: '600px',
               margin: '0 auto',
               lineHeight: '1.6'
             }}>
               Celebrating excellence and innovation using Chatbot Factory platform
             </p>
          </div>

          {/* Rewards Program Section */}
          <div style={{
            marginBottom: '40px'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              Rewards Program
            </h2>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '24px'
            }}>
                {/* Groceries eGift Card */}
                <div style={{
                  background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid #a855f7',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    fontSize: '2.5rem',
                    marginBottom: '16px'
                  }}>
                    🛒
                  </div>
                  <h3 style={{
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    color: '#581c87',
                    marginBottom: '16px'
                  }}>
                    Groceries eGift Card
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: '0',
                    fontSize: '0.9rem',
                    color: '#581c87',
                    textAlign: 'left',
                    flex: 1,
                    marginBottom: '16px',
                    lineHeight: '1.6'
                  }}>
                    <li style={{ marginBottom: '6px' }}>• Usable for groceries at Coles supermarkets Australia-wide</li>
                    <li style={{ marginBottom: '6px' }}>• Valid for online or in-store purchases</li>
                    <li style={{ marginBottom: '6px' }}>• Delivered instantly via email</li>
                    <li style={{ marginBottom: '6px' }}>• Redeem at checkout using your unique barcode or card number</li>
                  </ul>
                  <div style={{
                    paddingTop: '16px',
                    borderTop: '1px solid #d8b4fe',
                    marginTop: 'auto'
                  }}>
                    <a
                      href="https://corporateservices.giftcards.com.au/CMS/Page/TermsandConditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: '0.85rem',
                        color: '#7c3aed',
                        textDecoration: 'none',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                    >
                      See Coles Gift Card T&Cs
                      <i className="fas fa-external-link-alt" style={{ fontSize: '10px' }}></i>
                    </a>
                  </div>
                </div>

                {/* Youfoodz eGift Card */}
                <div style={{
                  background: 'linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%)',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid #9333ea',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    fontSize: '2.5rem',
                    marginBottom: '16px'
                  }}>
                    🍽️
                  </div>
                  <h3 style={{
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    color: '#581c87',
                    marginBottom: '16px'
                  }}>
                    Youfoodz eGift Card
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: '0',
                    fontSize: '0.9rem',
                    color: '#581c87',
                    textAlign: 'left',
                    flex: 1,
                    marginBottom: '16px',
                    lineHeight: '1.6'
                  }}>
                    <li style={{ marginBottom: '6px' }}>• Fresh, healthy ready-made meals delivered to most major cities and regional centres across Australia</li>
                    <li style={{ marginBottom: '6px' }}>• Valid for online purchases only</li>
                    <li style={{ marginBottom: '6px' }}>• Receive via email (usually within 4 hours)</li>
                    <li style={{ marginBottom: '6px' }}>• Redeem at checkout using your unique code</li>
                  </ul>
                  <div style={{
                    paddingTop: '16px',
                    borderTop: '1px solid #d8b4fe',
                    marginTop: 'auto'
                  }}>
                    <a
                      href="https://www.youfoodz.com/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: '0.85rem',
                        color: '#7c3aed',
                        textDecoration: 'none',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                    >
                      See Youfoodz T&Cs
                      <i className="fas fa-external-link-alt" style={{ fontSize: '10px' }}></i>
                    </a>
                  </div>
                </div>

                {/* Holiday Destination Voucher */}
                <div style={{
                  background: 'linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid #7c3aed',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    fontSize: '2.5rem',
                    marginBottom: '16px'
                  }}>
                    ✈️
                  </div>
                  <h3 style={{
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    color: '#4c1d95',
                    marginBottom: '16px'
                  }}>
                    Holiday Destination Voucher
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: '0',
                    fontSize: '0.9rem',
                    color: '#4c1d95',
                    textAlign: 'left',
                    flex: 1,
                    marginBottom: '16px',
                    lineHeight: '1.6'
                  }}>
                    <li style={{ marginBottom: '6px' }}>• Accommodation reward – valued up to $1,000 depending on location</li>
                    <li style={{ marginBottom: '6px' }}>• Hotel stay only (selected locations & dates)</li>
                    <li style={{ marginBottom: '6px' }}>• Flights, meals, or transport are not included</li>
                    <li style={{ marginBottom: '6px' }}>• Taxes, booking fees & resort fees may apply</li>
                    <li style={{ marginBottom: '6px' }}>• Valid for 18 months once redeemed</li>
                  </ul>
                  <div style={{
                    paddingTop: '16px',
                    borderTop: '1px solid #c4b5fd',
                    marginTop: 'auto'
                  }}>
                    <a
                      href="https://www.redeemvacations.com/how-it-works"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: '0.85rem',
                        color: '#7c3aed',
                        textDecoration: 'none',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                    >
                      Full Vacation Reward Terms
                      <i className="fas fa-external-link-alt" style={{ fontSize: '10px' }}></i>
                    </a>
                  </div>
                </div>
            </div>
          </div>

          {/* Monthly Challenges Section */}
          <div style={{
            marginBottom: '40px'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              Monthly Challenges
            </h2>
            
            <div style={{
              background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '1px solid #0ea5e9'
            }}>
                             <h3 style={{
                 fontSize: '1.3rem',
                 fontWeight: '700',
                 color: '#0c4a6e',
                 marginBottom: '16px',
                 textAlign: 'center'
               }}>
                 🚀 Innovation Challenge
               </h3>
                             <div style={{
                 display: 'grid',
                 gridTemplateColumns: '1fr auto',
                 gap: '32px',
                 marginTop: '20px',
                 alignItems: 'center'
               }}>
                 <div style={{
                   background: 'white',
                   padding: '24px',
                   borderRadius: '12px',
                   border: '1px solid #0ea5e9'
                 }}>
                   <h4 style={{
                     fontSize: '1.1rem',
                     fontWeight: '700',
                     color: '#0c4a6e',
                     marginBottom: '16px'
                   }}>
                     Challenge Details
                   </h4>
                                       <p style={{
                      fontSize: '1rem',
                      color: '#0c4a6e',
                      marginBottom: '16px',
                      lineHeight: '1.6'
                    }}>
                      Create the most innovative chatbot that solves a real-world problem. 
                      Winners will receive cash prizes, mentorship opportunities, and feature 
                      placement in our showcase.
                    </p>
                                       <ul style={{
                      listStyle: 'none',
                      padding: '0',
                      fontSize: '0.9rem',
                      color: '#0c4a6e',
                      lineHeight: '1.6'
                    }}>
                      <li style={{ marginBottom: '8px' }}>• Special prizes for most innovative solutions</li>
                      <li>• Winners announced monthly</li>
                    </ul>
                 </div>
                 
                 <div style={{
                   display: 'flex',
                   flexDirection: 'column',
                   alignItems: 'center',
                   gap: '16px'
                 }}>
                  <button 
                      onClick={() => window.open('https://urcommunity.org/rewards/', '_blank')}
                      style={{
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '16px 32px',
                        fontSize: '1.1rem',
                        fontWeight: '700',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(14, 165, 233, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(14, 165, 233, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 12px rgba(14, 165, 233, 0.3)';
                      }}>
                      🏆 Check Winners
                    </button>
                   <p style={{
                     fontSize: '0.85rem',
                     color: '#0c4a6e',
                     textAlign: 'center',
                     maxWidth: '200px',
                     lineHeight: '1.4'
                   }}>
                     View current winners and their innovative solutions
                   </p>
                 </div>
               </div>
            </div>
          </div>

          {/* How to Participate Section */}
          <div style={{
            background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
            borderRadius: '16px',
            padding: '24px',
            border: '1px solid #22c55e'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '700',
              color: '#14532d',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              How to Participate
            </h2>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              <div style={{
                textAlign: 'center',
                padding: '16px'
              }}>
                <div style={{
                  fontSize: '2.5rem',
                  marginBottom: '12px'
                }}>
                  1️⃣
                </div>
                                 <h3 style={{
                   fontSize: '1.1rem',
                   fontWeight: '700',
                   color: '#14532d',
                   marginBottom: '8px'
                 }}>
                   Create Your Chatbot
                 </h3>
                 <p style={{
                   fontSize: '0.9rem',
                   color: '#14532d',
                   lineHeight: '1.5'
                 }}>
                   Build and deploy your chatbot using our platform
                 </p>
              </div>
              
              <div style={{
                textAlign: 'center',
                padding: '16px'
              }}>
                <div style={{
                  fontSize: '2.5rem',
                  marginBottom: '12px'
                }}>
                  2️⃣
                </div>
                                 <h3 style={{
                   fontSize: '1.1rem',
                   fontWeight: '700',
                   color: '#14532d',
                   marginBottom: '8px'
                 }}>
                   Track Performance
                 </h3>
                 <p style={{
                   fontSize: '0.9rem',
                   color: '#14532d',
                   lineHeight: '1.5'
                 }}>
                   Monitor your chatbot's performance and user satisfaction
                 </p>
              </div>
              
              <div style={{
                textAlign: 'center',
                padding: '16px'
              }}>
                <div style={{
                  fontSize: '2.5rem',
                  marginBottom: '12px'
                }}>
                  3️⃣
                </div>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  color: '#14532d',
                  marginBottom: '8px'
                }}>
                  Win Rewards
                </h3>
                <p style={{
                  fontSize: '0.9rem',
                  color: '#14532d',
                  lineHeight: '1.5'
                }}>
                  Earn points, climb tiers, and win monthly challenges
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
        <Footer />
      </div>
    </>
  );
};

export default RewardsPage;
